var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineBoardSideicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24999 12.7085C6.09166 12.7085 5.93333 12.6502 5.80833 12.5252C5.56666 12.2835 5.56666 11.8835 5.80833 11.6419L8.47499 8.9752C8.60833 8.84186 8.78333 8.7752 8.97499 8.79186C9.15833 8.80853 9.32499 8.90853 9.43333 9.06686L10.3417 10.4335L13.3 7.4752C13.5417 7.23353 13.9417 7.23353 14.1833 7.4752C14.425 7.71686 14.425 8.11686 14.1833 8.35853L10.6833 11.8585C10.55 11.9919 10.375 12.0585 10.1833 12.0419C9.99999 12.0252 9.83333 11.9252 9.72499 11.7669L8.81666 10.4002L6.69166 12.5252C6.56666 12.6502 6.40833 12.7085 6.24999 12.7085Z",
    fill: "#909AB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10.2082C13.4083 10.2082 13.125 9.92484 13.125 9.58317V8.5415H12.0833C11.7416 8.5415 11.4583 8.25817 11.4583 7.9165C11.4583 7.57484 11.7416 7.2915 12.0833 7.2915H13.75C14.0916 7.2915 14.375 7.57484 14.375 7.9165V9.58317C14.375 9.92484 14.0916 10.2082 13.75 10.2082Z",
    fill: "#909AB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.9582H7.50002C2.97502 18.9582 1.04169 17.0248 1.04169 12.4998V7.49984C1.04169 2.97484 2.97502 1.0415 7.50002 1.0415H12.5C17.025 1.0415 18.9584 2.97484 18.9584 7.49984V12.4998C18.9584 17.0248 17.025 18.9582 12.5 18.9582ZM7.50002 2.2915C3.65835 2.2915 2.29169 3.65817 2.29169 7.49984V12.4998C2.29169 16.3415 3.65835 17.7082 7.50002 17.7082H12.5C16.3417 17.7082 17.7084 16.3415 17.7084 12.4998V7.49984C17.7084 3.65817 16.3417 2.2915 12.5 2.2915H7.50002Z",
    fill: "#909AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBoardSideicon);
export default __webpack_public_path__ + "static/media/Line Board - side icon.e5f7e579c77a3b6dc7d60ae71917d472.svg";
export { ForwardRef as ReactComponent };